import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PlacesAutocomplete from 'react-places-autocomplete';
import API from "@beardeddevops/react.api";
import { Button } from "reactstrap";
import {Call_Geocode_API} from "../../constants/Utilities";
import {loadGoogleMaps} from "../../constants/GoogleMaps";

export default class AddressLong extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		parent: PropTypes.object.isRequired,
		prefix: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.state = {
			state: this.props.object.state || "",
			street_1: this.props.object.street_1 || "",
			city: this.props.object.city || "",
			zip: this.props.object.zip || "",
			full_address: this.props.object.full_address || "",
			mapsReady: false,
		};
	}

	async componentDidMount() {
		await loadGoogleMaps();
		this.setState({ mapsReady: true });
	}

	componentDidUpdate(prevProps) {
		if (prevProps.object.state !== this.props.object.state) {
			this.setState({ state: this.props.object.state || "" });
		}

		if (prevProps.object.full_address !== this.props.object.full_address) {
			this.setState({
				full_address: this.props.object.full_address || ""
			});
		}

		if (prevProps.object.street_1 !== this.props.object.street_1) {
			this.setState({
				street_1: this.props.object.street_1 || "",
			});
		}

		if (prevProps.object.city !== this.props.object.city) {
			this.setState({ city: this.props.object.city || "" });
		}

		if (prevProps.object.zip !== this.props.object.zip) {
			this.setState({ zip: this.props.object.zip || "" });
		}

		if (
			this.props.validateAddress &&
			prevProps.validateAddress !== this.props.validateAddress &&
			this.props.validateAddress !== 'validated'
		) {
			this.handleSelect(this.props.validateAddress);
		}
	}

	handleChange = (street_1) => {
		this.setState({ street_1 });
		this.props.parent.state.street_1 = street_1;
		this.props.parent.state.latitude = null;
		this.props.parent.state.longitude = null;

		if (typeof this.props.searchChange === 'function') {
			this.props.searchChange(street_1);
		}
	};

	loadRegion = async (lat, lng) => {
		let modelRegion = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ);
		modelRegion.filter = {
			latitude: lat,
			longitude: lng,
		};

		const regional = await modelRegion.submit(null, 'GET_REGION', true);

		if (regional && Object.keys(regional).length > 0) {
			this.props.parent.state.region = regional.regionPkey;
			this.props.parent.handleSelectPropertyUpdate();

			if (typeof this.props.parent.props.regionChange === 'function') {
				this.props.parent.props.regionChange(regional.regionName, regional.regionPkey);
			}

			if (typeof this.props.parent.props.updateRegion === 'function') {
				this.props.parent.props.updateRegion(regional.regionPkey, regional.regionName);
			}
		}

		if (typeof this.props.parent.props.updateGivenAddress === 'function') {
			this.props.parent.props.updateGivenAddress(lat, lng);
		}
	};

	handleSelect = async (selectedAddress) => {
		try {
			const geo = await Call_Geocode_API(selectedAddress);

			if (!geo || geo.latitude == null || geo.longitude == null) {
				this.props.parent.state.validated = 'error';
				return;
			}

			this.setState({
				state: geo.state || "",
				street_1: geo.street_1 || "",
				city: geo.city || "",
				zip: geo.zip || "",
				full_address: geo.formatted_address || "",
			});

			this.props.parent.state.street_1 = geo.street_1 || "";
			this.props.parent.state.city = geo.city || "";
			this.props.parent.state.state = geo.state || "";
			this.props.parent.state.zip = geo.zip || "";
			this.props.parent.state.latitude = geo.latitude;
			this.props.parent.state.longitude = geo.longitude;
			this.props.parent.state.validateAddress = 'validated';

			await this.loadRegion(geo.latitude, geo.longitude);
		} catch (error) {
			console.error('Error selecting address', error);
			this.props.parent.state.validated = 'error';
		}
	};

	findClosetFE = () => {
		let Address = {
			street_1: this.props.parent.state.street_1,
			city: this.props.parent.state.city,
			state: this.props.parent.state.state,
			zip: this.props.parent.state.zip,
			latitude: this.props.parent.state.latitude,
			longitude: this.props.parent.state.longitude,
			region: this.props.parent.state.region,
		};

		localStorage.setItem('findFEAddress', JSON.stringify(Address));
		window.open('/dispatch/closest');
	};

	render() {
		let object = this.props.object;
		let properties = this.props.properties;
		let { parent, prefix } = this.props;
		prefix = prefix || '';

		const addressValue = [this.state.street_1, this.state.city, this.state.state, this.state.zip].filter(Boolean).join(', ');

		return (
			<fieldset>
				<div className="form-group">
					{this.state.mapsReady ? (
					<PlacesAutocomplete
						value={addressValue}
						onChange={this.handleChange}
						onSelect={this.handleSelect}
					>
						{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
							<div>
								<input
									{...getInputProps({
										placeholder: 'Street',
										className: 'location-search-input',
									})}
									style={{ width: "100%", height: "32px" }}
									type="search"
								/>
								<div className="autocomplete-dropdown-container">
									{loading && <div>Loading...</div>}
									{suggestions.map((suggestion, index) => {
										const className = suggestion.active
											? 'suggestion-item--active'
											: 'suggestion-item';

										return (
											<div
												{...getSuggestionItemProps(suggestion, { className })}
												key={`suggestion-${index}`}
											>
												<span>{suggestion.description}</span>
											</div>
										);
									})}
								</div>
							</div>
						)}
					</PlacesAutocomplete>
					) : (
						<input
							placeholder="Street"
							className="location-search-input"
							style={{ width: "100%", height: "32px" }}
							type="search"
							value={addressValue}
							disabled
						/>
					)}
				</div>

				{this.props.findFE && (
					<div className={"form-group"}>
						<Button size="block" onClick={this.findClosetFE} color="primary">
							Find Closest FE
						</Button>
					</div>
				)}
			</fieldset>
		);
	}
}